<template>
  <div
    class="modal-backdrop"
    @click="close"
  >
    <div
      class="modal"
      @click="stopEvent"
    >
      <div name="header" />
      <div
        id="body"
        name="body"
      >
        <p
          class="buy-later"
          @click="close"
        >
          稍后购买
        </p>
        <div class="info-area">
          <img
            v-if="product.photoUrl"
            :src="product.photoUrl"
          >
          <div>
            <p v-if="product.name">
              {{ product.name }}
            </p>
            <p>{{ product.version }}</p>
            <p>
              USD <span
                v-if="product.originalPrice !== product.price"
                class="discount"
              >${{ product.originalPrice }}</span> ${{ product.price }}
            </p>
          </div>
        </div>
        <div
          v-if="!product.paymentUrl"
          class="payment-area coupon-area"
        >
          <div class="coupon-input">
            <input
              v-model="coupon"
              type="text"
              placeholder="若您有优惠码，请在此输入"
            ><button @click="getPrice({ coupon })">
              确认
            </button>
          </div>
          <div class="coupon-error">
            <p v-if="!couponError">
&nbsp;
            </p>
            <p v-else>
              {{ couponError }}
            </p>
          </div>
          <div class="coupon-container">
            <div>
              <p>{{ product.name }} {{ product.version }}</p>
              <p>${{ product.originalPrice }}</p>
            </div>
            <div>
              <p>升級优惠</p>
              <p v-if="product.originalPrice">
                ${{ product.originalPrice - product.upgradePrice }}
              </p>
              <p v-else>
                $0
              </p>
            </div>
            <div>
              <p>优惠码金额</p>
              <p v-if="product.originalPrice">
                ${{ product.upgradePrice - product.price }}
              </p>
              <p v-else>
                $0
              </p>
            </div>
            <div>
              <p>总价</p>
              <p>${{ product.price }}</p>
            </div>
            <button
              @click="getAlipaySecret({ coupon })"
            >
              去支付
            </button>
            <!-- <button
              @click="getCheckoutQr({ coupon })"
            >
              去支付
            </button> -->
          </div>
        </div>
        <div
          v-else
          class="payment-area"
        >
          <p class="payment-text">
            使用微信扫描支付
          </p>
          <div>
            <qrcode :value="product.paymentUrl" />
          </div>
          <!-- <a @click="hideQr()">等等，我有优惠码！</a> -->
          <p>付款完成后，您将会收到电子邮件通知。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalVideo from '@/components/modal-video'
import store from '@/store'
import { mapActions, mapMutations, mapState } from 'vuex'
import VueQrcode from '@chenfengyuan/vue-qrcode'

export default {
  store,
  components: {
    qrcode: VueQrcode
  },
  mixins: [ModalVideo],
  data () {
    return {}
  },
  computed: {
    coupon: {
      get () {
        return this.$store.state.ModalBuy.coupon
      },
      set (data) {
        return this.$store.commit('ModalBuy/UPDATE_COUPON', data)
      }
    },
    ...mapState('ModalBuy', {
      product: 'product',
      couponError: 'error'
    })
  },
  methods: {
    stopEvent (event) {
      event.stopPropagation()
    },
    ...mapActions('ModalBuy', {
      getCheckoutQr: 'getCheckoutQr',
      getAlipaySecret: 'getAlipaySecret',
      getPrice: 'getPrice'
    }),
    ...mapMutations('ModalBuy', {
      close: 'HIDE_BUY_MODAL',
      hideQr: 'HIDE_QR',
      updateCoupon: 'UPDATE_COUPON'
    })
  }
}
</script>

<style scoped lang="scss">
@import "../styles/base/breakpoint.scss";

.buy-later {
  text-align: right;
  margin: 17px;
}

.buy-later:hover {
  text-decoration: underline;
}

img {
  height: 140px;
  width: 238px;
}

.modal-backdrop {
  z-index: 2;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  z-index: 3;
  background: #282828;
  box-shadow: 0 2px 23px 0 rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  width: 98vw;

  @include breakpoint("small") {
    width: 40vw;
  }
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  border-bottom: 1px solid #eeeeee;
  color: #4AAE9B;
  justify-content: space-between;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
  justify-content: flex-end;
}

.modal-body {
  position: relative;
  padding: 20px 10px;
}

.btn-close {
  border: none;
  font-size: 20px;
  padding: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #4AAE9B;
  background: transparent;
}

.btn-green {
  color: white;
  background: #4AAE9B;
  border: 1px solid #4AAE9B;
  border-radius: 2px;
}

.info-area {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  @include breakpoint("large") {
    text-align: unset;
  }
}

.info-area > div {
}

.info-area p {
  display: inline-block;
}

.info-area p:nth-of-type(1) {
  font-size: 24px;
  font-weight: bold;
}
.info-area p:nth-of-type(2) {
  font-size: 20px;
  color: #c1af84;
  margin: 0 8px;
}
.info-area p:nth-of-type(3) {
  font-size: 24px;
}

.payment-area {
  background-color: #363636;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 10px;
}

.payment-area p {
  display: inline-block;
}

.payment-text {
  position: relative;
}

.payment-text::after {
  content: "";
  position: absolute;
  top: 52%;
  background: #5f5f5f;
  width: 80px;
  height: 1px;
  left: -88px;
}

.payment-text::before {
  content: "";
  position: absolute;
  top: 52%;
  background: #5f5f5f;
  width: 80px;
  height: 1px;
  left: 135px;
}

.discount {
  text-decoration: line-through;
}

.coupon-container {
  margin-top: 12px;
}
.coupon-container div {
  display: flex;
  justify-content: space-between;
}
.coupon-container p {
  margin-bottom: 0.5rem;
  margin-top: 0;
  color: #d2d2d2;
  line-height: 1.5rem;
  font-size: 15px;
}
.coupon-container div p:nth-of-type(2) {
  color: white;
}
.coupon-container div:nth-of-type(5) p {
  font-size: 20px;
}
.coupon-container button {
  width: 100%;
}

.coupon-input {
  display: flex;
  justify-content: center;
  align-items: center;
}
.coupon-input button {
  height: 32px;
  padding: 1px;
  background-color: #8a8a8a;
  color: white;
}
.coupon-input button .done {
  color: rgba(0,0,0,0.5);
}

.coupon-input input {
  width: 80%;
  margin-right: 5%;
  background-color: unset;
  border: solid 1px #8a8a8a;
  border-radius: 4px;
  color: #d2d2d2;
  height: 30px;
  font-size: 14px;
  padding: 0;
  padding-left: 0.5rem;
}
.coupon-input p {
  display: block;
}

.coupon-area {
  padding-top: 5%;
  padding-bottom: 5%;
  > div {
    width: 80%;
  }
}

.payment-area a {
  text-decoration: underline;
}
.coupon-error p {
  color: #dd4415;
}
</style>



// WEBPACK FOOTER //
// src/components/modal-buy.vue